import { createApp } from "vue";
import App from "./App.vue";
import "maz-ui/css/main.css";

createApp(App).mount("#app");
